// extracted by mini-css-extract-plugin
export default {"checkbox":"t10cz7","checkboxError":"pfU0k8"};